import { css } from 'styled-components';

export const breakpoints = {
  sm: 768,
  md: 1024,
  mid:1020,
  nav: 725,
  dosingImgs: 600,
  modalSm: 420,
  modalMd: 660,
  circleGraphLg: 900,
};


export const respondTo = Object.keys(breakpoints).reduce(
  (acc, label) => {
    acc[label] = (...args) => css`
      @media (min-width: ${breakpoints[label]}px) {
        ${css(...args)};
      }
    `;
// Add max-width media query
    acc[`max${label}`] = (...args) => css`
      @media (max-width: ${breakpoints[label]}px) {
        ${css(...args)};
      }
    `;
    return acc;
  },
  {},
);
respondTo.maxWidth1020 = (...args) => css`
  @media (max-width: 1020px) {
    ${css(...args)};
  }
`;

// Example Usage:

// export const ExampleComponent = styled.div`
//   background-color: lime;
//
//   ${respondTo.sm`
//     background-color: aqua;
// `  }
// `;
